const baseConfig = {
  baseServerUrl: "",
  playVideoUrl: "/vid/m3u8/", //视频播放
  imgUrl: "", //图片预览
  newImgUrl: "", //图片预览
  downLoadUrl: "" //视频下载
}
if (
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_TITLE === "test"
) {
  baseConfig.baseServerUrl = "https://xv2ht.cestalt.com/api/web/admin"
} else if (process.env.NODE_ENV === "development") {
  // 测试服
  baseConfig.baseServerUrl = "https://xv2ht.cestalt.com/api/web/admin"
} else {
  baseConfig.baseServerUrl = "/api/web/admin"
}
export default baseConfig